__webpack_require__.p = "/corporate-training/_next/";